import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cohrex-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SvgComponent {
  @Input() name?: string = '';
  @Input() fill?: string = 'tw-fill-white';
  @Input() stroke?: string = '';
}
